import { render, staticRenderFns } from "./ProtocolSettings.vue?vue&type=template&id=095ed709&scoped=true"
import script from "./ProtocolSettings.vue?vue&type=script&lang=js"
export * from "./ProtocolSettings.vue?vue&type=script&lang=js"
import style0 from "./ProtocolSettings.vue?vue&type=style&index=0&id=095ed709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ed709",
  null
  
)

export default component.exports